import React from 'react';

const LeftArrow = () => (
  <svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 4H1.5M1.5 4L5 0.5M1.5 4L5 7.5" stroke="#004379" />
  </svg>
);

export default LeftArrow;
